// /opt/isp_erp/frontend/src/api/schedule.api.js
import api from './axios';

export const scheduleAPI = {
  // Verificar disponibilidad de un técnico
  checkAvailability: async (technicianId, scheduledDate, durationMinutes = 90) => {
    const response = await api.post('/schedule/check-availability', {
      technician_id: technicianId,
      scheduled_date: scheduledDate,
      duration_minutes: durationMinutes
    });
    return response.data;
  },

  // Obtener calendario de un técnico
  getTechnicianSchedule: async (technicianId, startDate, endDate) => {
    const response = await api.get(`/schedule/technician/${technicianId}`, {
      params: {
        start_date: startDate.toISOString(),
        end_date: endDate.toISOString()
      }
    });
    return response.data;
  },

  // Obtener horarios disponibles
  getAvailableSlots: async (technicianId, date, durationMinutes = 90) => {
    const response = await api.get(`/schedule/available-slots/${technicianId}`, {
      params: {
        date: date.toISOString(),
        duration_minutes: durationMinutes
      }
    });
    return response.data;
  }
};
